import * as React from 'react';

import { InlineInput } from 'src/components/Inputs';
import { useContext } from 'react';
import { InputContext } from 'src/contexts/input.context';
import { DateCalendarDropdown, DateCalendarDropdownInputProps } from '../DateCalendarDropdown';

export function InlineDateCalendarDropdown() {
  const { classNames, isDisabled, isReadonly, isAutoFocus } = useContext(InputContext);

  function handleOnFocus(callback: () => void) {
    return function call(e: React.FocusEvent) {
      e.preventDefault();
      callback();
    };
  }

  function renderInput({ onClick, onFocus, onBlur, value, onSubmit, onDiscard }: DateCalendarDropdownInputProps) {
    return (
      <InlineInput
        className={classNames?.input}
        value={value}
        onFocus={handleOnFocus(onFocus)}
        onClick={onClick}
        onBlur={onBlur}
        isDisabled={isDisabled}
        autoFocus={isAutoFocus}
        onSubmit={onSubmit}
        onDiscard={onDiscard}
        isReadonly={isReadonly}
      />
    );
  }

  return <DateCalendarDropdown renderInput={renderInput} />;
}
